<script>
    import { Router, Route } from "svelte-routing";
    import { api_host, toast_options, domain_code_store, user_store, bam_domain, price_settings_store, avatar_store, site_activate_store, places_store, plan_type_store, page_setting_store } from './stores.js';
    import RedirectToHome from './pages/RedirectToHome.svelte';
    import BookingForm from "./pages/BookingForm.svelte";
    import ServiceInfo from "./pages/ServiceInfo.svelte";
    import ContactUs from "./pages/ContactUs.svelte";
    import GiftCards from "./pages/GiftCards.svelte";
    import Jobs from "./pages/Jobs.svelte";
    import Login from "./pages/Login.svelte";
    import Logout from "./pages/Logout.svelte";
    import Activate from "./pages/Activate.svelte";
    import ResetPassword from "./pages/ResetPassword.svelte";
    import Profile from "./pages/Profile.svelte";
    import ProfileEdit from "./pages/ProfileEdit.svelte";
    import Loading from "./pages/Loading.svelte";
    import ConfirmMessage from './pages/ConfirmMessage.svelte';
    import InvalidAddress from './pages/InvalidAddress.svelte';
    import { SvelteToast } from '@zerodevx/svelte-toast';
    import { onMount } from "svelte";
    import { getToken, doFetch } from './utils/Fetching.svelte';
    import FreeServiceInfo from "./pages/FreeServiceInfo.svelte";
    import JobsByUser from "./pages/JobsByUser.svelte";
    import JobReview from "./pages/JobReview.svelte";
    import Referral from "./pages/Referral.svelte";
    import ReferralDone from "./pages/ReferralDone.svelte";
    import BookSearch from "./pages/BookSearch.svelte";
    import BookEmbed from "./pages/BookEmbed.svelte";
    import QuoteReview from "./pages/QuoteReview.svelte";


    let myself = {};
    let is_embed = false;
    if (window.location.href.includes('embed')) {
        is_embed = true;
    }

    user_store.subscribe(value => {
        myself = value;
    });

    setTimeout(()=>{window.scrollTo(0, 0);}, 1000);

    export const url = "";
    let is_loaded = false;
    onMount(async () => {
        const domain_obj = await doFetch(`${api_host}/api/domain/get/current`, 'GET');
        console.log('/api/domain/get/current', domain_obj);
        domain_code_store.set(domain_obj ? domain_obj.code : '');
        site_activate_store.set(domain_obj ? domain_obj.is_subscribed : false);
        plan_type_store.set(domain_obj ? domain_obj.plan_type : '');

        const price_setting_res = await doFetch(
            api_host + `/api/landscaper/get/price_setting_public`,
            'GET',
            {},
            { 'DomainCode': domain_obj.code }
        );
        if (price_setting_res.status) {
            price_settings_store.set(price_setting_res.price_settings);
            avatar_store.set(price_setting_res.avatar);
        }

        const places_res = await doFetch(
            api_host + `/api/landscaper/get/places/public`,
            'POST',
            { domain_name: window.location.host },
            { 'Content-Type': 'application/json', 'DomainCode': domain_obj.code }
        );
        if (places_res.status) {
            places_store.set(places_res.places);
        }

        const page_setting_res = await doFetch(
            `${api_host}/api/landscaper/get/page_setting_public`,
            'GET',
            {},
            { 'DomainCode': domain_obj.code, 'Content-Type': 'application/json' }
        );
        if (page_setting_res.status) {
            page_setting_store.set(page_setting_res.page_setting);
            console.log(page_setting_res.page_setting)
        }

        const { auth_type, auth_token } = getToken();
        const res = await doFetch(
            api_host + `/auth/user`,
            'GET',
            {},
            { Authorization: `${auth_type} ${auth_token}`, 'Content-Type': 'application/json', 'DomainCode': domain_obj.code }
        );
        if (res['role'] === 'manager' || res['role'] === 'admin') {
            localStorage.removeItem('HoyToKenTy');
            localStorage.removeItem('HoyToKenTo');
            localStorage.removeItem('HoyDomainCode');
            window.location.href = `${$bam_domain}/setupauth?auth_type=${auth_type}&auth_token=${auth_token}&domain_code=${domain_obj.code}`;
            return;
        }
        if (res['id']) {
            if (res.plan_type !== 'prime' && res.plan_type !== 'free') {
                // localStorage.removeItem('HoyToKenTy');
                // localStorage.removeItem('HoyToKenTo');
                // localStorage.removeItem('HoyDomainCode');
                // window.location.href = '/';
            }
            user_store.update(prev => {
                is_loaded = true;
                prev['is_authenticated'] = true;
                prev['user'] = res;
                return prev;
            });
        } else {
            // const pathname = window.location.pathname;
            // if (res['detail'] && (pathname.includes('booking') || pathname.includes('dashboard'))) {
            //     const failed_detail = res['detail'].toLowerCase();
            //     if (failed_detail.includes('invalid token') || failed_detail.includes('unauthorized') || failed_detail.includes('expired')) {
            //         window.location.href = '/login';
            //     }
            // }
            if (window.location.href.includes('dashboard')) {
                window.location.href = '/login';
            } else if (window.location.href.includes('register')) {
                return;
            } else {
                user_store.update(prev => {
                    is_loaded = true;
                    prev['is_authenticated'] = false;
                    return prev;
                });
            }
        }
    });
</script>


<svelte:head>
    {#if !is_embed}
        <script src="https://www.google.com/recaptcha/api.js?render=6LczIjMgAAAAAA7Iat2xKfRAz7HLG5cHI-lno56y"></script>
    {/if}
</svelte:head>


<SvelteToast options={$toast_options} />

{#if is_loaded}
<div class='maincontent'>
    <Router url='{url}'>
        <Route path='/embed'><BookEmbed /></Route>
        <Route path='/booking'><BookingForm /></Route>
        <Route path='/book_service'><BookSearch /></Route>
        <Route path='/serviceinfo'><ServiceInfo /></Route>
        <Route path='/freeservice'><FreeServiceInfo /></Route>
        <Route path='/'><RedirectToHome /></Route>
        {#if myself['is_authenticated'] && myself['user']['plan_type'] === 'free' && myself['user']['is_subscribed']}
            <Route path='/jobs'><JobsByUser /></Route>
            <Route path='/profile'><Profile /></Route>
            <Route path='/edit_profile'><ProfileEdit /></Route>
        {:else}
            <Route path='/jobs'><Jobs /></Route>
            <Route path='/profile'><RedirectToHome /></Route>
            <Route path='/edit_profile'><RedirectToHome /></Route>
        {/if}
        <Route path='/job_review/:jid' let:params><JobReview params='{params}' /></Route>
        <Route path='/giftcards'><GiftCards /></Route>
        <Route path='/referral'><Referral /></Route>
        <Route path='/referral_done/:recipient_name' let:params><ReferralDone params='{params}' /></Route>
        <Route path='/contact'><ContactUs /></Route>
        <Route path='/login'><Login /></Route>
        <Route path='/logout'><Logout /></Route>
        <Route path='/activate/:uid/:token/:userId' let:params><Activate params='{params}' /></Route>
        <Route path='/reset_password/:uid/:token/:userId/:userEmail' let:params><ResetPassword params='{params}'/></Route>
        <Route path='/home'><RedirectToHome /></Route>
        <Route path='/book_confirm'><ConfirmMessage /></Route>
        <Route path='/invalid_address'><InvalidAddress /></Route>
        <Route path='/quote/:slug' let:params><QuoteReview params='{params}' /></Route>
    </Router>
    {#if !is_embed}
    <div class="powered-by-footer">
        <div class="powered-by-line"></div>
        <div class="powered-by-text">
            <span class="powered-by-label">Powered by </span>
            <a href="https://app.houseofyards.com" target="_blank" rel="noopener noreferrer" class="powered-by-link">House of Yards App</a>
        </div>
    </div>
    {/if}
</div>
{:else}
<Loading />
{/if}


<style>
    .maincontent {
        padding-left: 15px;
        padding-right: 15px;
        margin: 0px;
        padding-bottom: 20px;
    }

    :global(body) {
        padding: 0 0 0 0 !important;
        margin: 0 0 0 0 !important;
    }

    .powered-by-footer {
        width: 100%;
        background-color: white;
        padding: 20px 0;
        text-align: center;
        margin-top: 40px;
    }

    .powered-by-line {
        width: 100%;
        height: 1px;
        background-color: #87CEEB;
        margin-bottom: 15px;
    }

    .powered-by-text {
        text-align: center;
    }

    .powered-by-label {
        color: #999999;
        font-size: 14px;
    }

    .powered-by-link {
        color: #009eeb;
        text-decoration: none;
        font-size: 14px;
        font-weight: 500;
    }

    .powered-by-link:hover {
        text-decoration: underline;
    }
</style>
